import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { BaseURL } from "../../Essentials/variables";
import axios from "axios";
import moment from 'moment';
import { set } from "lodash";
const buttonStyle = {
    backgroundColor: '#171C8F',
    border: 'none',
    color: 'white',
    padding: '10px 20px',
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: '16px',
    margin: '4px 2px',
    cursor: 'pointer',
  };
 
  const financialYears = [];
  for (let year = 2018; year <= new Date().getFullYear(); year++) {
    const nextYear = year + 1;
    const financialYear = `${year}-${nextYear.toString().substring(2, 4)}`;
    financialYears.push(financialYear);
  }
export default function DumpDownload(){

    const [month,setMonth]=useState("allmonth");
    const [year,setYear]=useState(parseInt(new Date().getFullYear().toString()))
    const [data,setData]=useState([]);
    const [fetch,setFetch]=useState(0);
    const fileName = `dump_data_${year}_${month}.csv`;
    // let data = [
    //     { firstname: "abc", lastname: "def", email: "abc@def" },
    //   ];  
    //   let headers = [
    //     { label: "First Name", key: "firstname" },
    //     { label: "Last Name", key: "lastname" },
    //     { label: "Email", key: "email" }
    //   ];
    let headers =[
        {label:"inv_datetime" , key:"inv_datetime"},
        {label:"inv_can_date" , key:"inv_can_date"},
        {label:"order_num" , key:"order_num"},
        {label:"vin" , key:"vin"},
        {label:"parent_group" , key:"parent_group"},
        {label:"dealer_type" , key:"dealer_type"},
        {label:"outlet_type" , key:"outlet_type"},
        {label:"dealer_cd" , key:"dealer_cd"},
        {label:"region" , key:"region"},
        {label:"zone" , key:"zone"},
        {label:"state" , key:"state"},
        {label:"district" , key:"district"},
        {label:"tehsil" , key:"tehsil"},
        {label:"village" , key:"village"},
        {label:"fy_year" , key:"fy_year"},
        {label:"inv_can_month" , key:"inv_can_month"},
        {label:"coverage" , key:"coverage"},
        {label:"month_cumm_coverage" , key:"month_cumm_coverage"},
        {label:"running_month_coverage" , key:"running_month_coverage"},
        {label:"cummulative_coverage" , key:"cummulative_coverage"}
      ]
    function fetchData(Type,value){
        let URL="";
        if (Type === "year") {
          setYear(value);
          URL=BaseURL+`dumpdownload/${value}/${month}`;
        }
        if (Type === "month") {
          setMonth(value);
          URL=BaseURL+`dumpdownload/${year}/${value}`;
        }
        console.log(Type,"Hebby",value);
        setFetch(1);
        axios({
            method:'GET',
            headers:{
                "x-access-token":localStorage.getItem('token'),
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Frame-Options': 'DENY',
                'Content-Security-Policy': "frame-ancestors 'none'",
                'Feature-Policy': "frame-ancestors 'none'"
            },
            withCredentials:false,    //https://dev.msilruralmaps.com/api/summary/state
            url:URL,
            })
            .then((res)=>{
              const updatedData = res.data.map(obj => {
                return {
                    ...obj,
                    inv_can_date: moment(obj.inv_can_date).format('YYYY-MM-DD HH:mm:ss'),
                    inv_datetime: moment(obj.inv_datetime).format('YYYY-MM-DD HH:mm:ss'),
                };
            });
                //  console.info(updatedData);
                setData(updatedData);
                setFetch(2);
            })
            .catch((err)=>{
                console.log(err);
            })     
    }
    // useEffect(()=>{
        
    // },[year,month])
    return (
        <section className="text-center mx-auto">
          <h1 className=" items-center mb-2 text-2xl font-semibold text-slate-200">
            <h1 className="text-3xl font-mono pt-8">Dump download </h1>
          </h1>
          <div className="pt-8 my-8 items-center ">
            <div className="rounded-lg shadow">
              <div className="flex">
                <div className="flex-auto mx-2">
                <select onChange={(e)=>{fetchData("year",e.target.value)}} className="block w-full border-gray-300 rounded px-28 py-1 leading-tight focus:outline-none focus:border-blue-500">
                  <option> Select FY-Year</option>
                  {financialYears.map((year) => (
                  <option
                    key={parseInt(year.substring(0, year.length - 3)) + 1}
                    value={parseInt(year.substring(0, year.length - 3)) + 1}
                  >
                    {`FY ${year}`}
                  </option>
                ))}
                </select>
                </div>
               <div className="flex-auto">
               <select
                  onChange={(e)=>{fetchData("month",e.target.value)}}
                  id=""
                  className="block w-full border-gray-300 rounded px-8 py-1 leading-tight focus:outline-none focus:border-blue-500"
                >
                  <option key="Se" value="allmonth">
                    All Month
                  </option>
                  <option key="pr" value="4">
                    April
                  </option>
                  <option key="ay" value="5">
                    May
                  </option>
                  <option key="June" value="6">
                    June
                  </option>
                  <option key="July" value="7">
                    July
                  </option>
                  <option key="ug" value="8">
                    August
                  </option>
                  <option key="ep" value="9">
                    September
                  </option>
                  <option key="ct" value="10">
                    October
                  </option>
                  <option key="ov" value="11">
                    November
                  </option>
                  <option key="ec" value="12">
                    December
                  </option>
                  <option key="an" value="1">
                    January
                  </option>
                  <option key="eb" value="2">
                    February
                  </option>
                  <option key="ar" value="3">
                    March
                  </option>
                </select>
               </div>
              </div>
            </div>
          </div>
          {fetch==2 && <CSVLink data={data} headers={headers} filename={fileName}>
              <button style={buttonStyle}>Download CSV</button>
          </CSVLink>}
          {fetch==1 && <p className="text-white">FETCHING DATA...</p>}
          {fetch==1 && month!='allmonth' &&  <p className="text-slate-500 text-sm">*It may take few seconds.</p>}
          {fetch==1 && month=='allmonth' &&  <p className="text-slate-500 text-sm">*It may take upto a minute.</p>}
          {fetch==1 && month=='allmonth' &&  <p className="text-slate-500 text-sm">*For quick response add month filter.</p>}
          {fetch==0 &&<p className="text-white">SELECT FILTERS</p>}
        </section>
      )
}